import guestCalendar from './guestCalendar.json';
export const GUEST_GUIDE_DEFAULT_LANGUAGE = 'en';
export const GUEST_HOME_DEFAULT_LANGUAGE = 'ko';
export const GUEST_GUIDE_SUPPORTED_LANGUAGES = ['en', 'fr', 'ko'];

export const GUEST_GUIDE_LANGUAGE_OPTIONS = [
  { id: 'en', label: 'English' },
  { id: 'fr', label: 'Français' },
  { id: 'ko', label: '한국어' }
];

export const GUEST_ARTIST_GUIDE_POLICY = {
  maxArtists: 3,
  tattooBeds: 3,
  openingHours: `${String(guestCalendar.openingHour).padStart(2, '0')}:00-${String(guestCalendar.closingHour).padStart(2, '0')}:00`,
  commissionRate: '30%',
  commissionDailyCap: '250€',
  assignedBedAdvance: '50€',
  priorityWindow: {
    en: 'one week',
    fr: 'une semaine',
    ko: '1주일'
  },
  address: '4 Rue Dunois, 75013 Paris',
  mapSearch: 'Gnegnegne Paris 13',
  instagramHandle: '@gnegnegn.e',
  instagramUrl: 'https://instagram.com/gnegnegn.e'
};

const policy = GUEST_ARTIST_GUIDE_POLICY;

export const GUEST_GUIDE_UPDATE_LABELS = {
  en: 'Last updated: October 12, 2026',
  fr: 'Dernière mise à jour : 12 octobre 2026',
  ko: '업데이트일 : 2026.10.12'
};

export const GUEST_HOME_TEXT = {
  en: {
    welcomeTo: 'WELCOME TO',
    guestArtist: 'Guest Artist',
    name: 'Name',
    status: 'Status',
    active: 'Active',
    period: 'Guest Period',
    commission: 'Your Commission Rate',
    notice: 'Add confirmed client appointments to the shared calendar promptly. Let us know about changes or cancellations before your working day.',
    fullGuideLink: 'View rates and bed booking →',
    openingHours: `OPEN ${policy.openingHours} (Closed Sunday)`
  },
  fr: {
    welcomeTo: 'BIENVENUE À',
    guestArtist: 'Artiste Invité',
    name: 'Nom',
    status: 'Statut',
    active: 'Actif',
    period: 'Période',
    commission: 'Votre taux de commission',
    notice: 'Inscrivez rapidement vos rendez-vous clients confirmés au calendrier partagé. Prévenez-nous des changements ou annulations avant votre jour de travail.',
    fullGuideLink: 'Voir les tarifs et la réservation de table →',
    openingHours: `OUVERT ${policy.openingHours} (Fermé le dimanche)`
  },
  ko: {
    welcomeTo: 'WELCOME TO',
    guestArtist: '게스트 아티스트',
    name: '이름',
    status: '상태',
    active: '활성',
    period: '게스트 기간',
    commission: '적용 커미션',
    notice: '확정된 고객 예약은 공유 캘린더에 바로 등록해 주세요. 변경·취소는 작업일 전에 알려주세요.',
    fullGuideLink: '이용 요금·베드 예약 안내 보기 →',
    openingHours: `OPEN ${policy.openingHours} (일요일 휴무)`
  }
};

export const GUEST_HOME_GUIDE = {
  ko: { title: '작업 전 확인', sections: [] },
  en: { title: 'Before you work', sections: [] },
  fr: { title: 'Avant votre journée', sections: [] }
};

// Author the comparison once. Existing native clients receive the same values
// as labelled bullets; the web can display them as a table.
function bedComparison(labels, options) {
  return {
    comparison: { labels, options },
    subsections: options.map(option => ({
      title: option.title,
      items: option.values.map((value, index) => `${labels[index]}: ${value}`),
      paragraphs: option.paragraphs
    }))
  };
}

export const GUEST_GUIDES = {
  ko: {
    title: '게스트 이용 안내',
    intro: '',
    summaryTitle: '이용 요금',
    summaryItems: [
      `하루 타투 매출의 ${policy.commissionRate} · 하루 최대 ${policy.commissionDailyCap}`,
      `월–토 ${policy.openingHours} · 일요일 휴무`
    ],
    sections: [
      {
        title: '베드 예약',
        paragraphs: ['날짜별로 아래 두 가지 중 선택할 수 있어요.'],
        ...bedComparison(['선결제', '자리 확보', '이용 방식'], [
          {
            title: '기본 예약',
            values: ['없음', `작업일 ${policy.priorityWindow.ko} 전까지 우선 확보`, '베드 미지정'],
            paragraphs: [`작업일까지 ${policy.priorityWindow.ko} 미만 남았는데 캘린더에 고객 예약이 없으면, 다른 레지던트 아티스트가 자리를 사용할 수 있어요. 고객 예약이 확정되면 바로 캘린더에 등록해 주세요.`]
          },
          {
            title: '종일 전용 베드',
            values: [`날짜당 ${policy.assignedBedAdvance}`, '고객 예약이 없어도 확보', '베드 1개를 종일 단독 사용'],
            paragraphs: [`선결제한 ${policy.assignedBedAdvance}는 당일 커미션에서 차감돼요. 결제 후 해당 베드는 다른 아티스트에게 배정하지 않으며, 선결제 금액은 어떤 경우에도 환불되지 않아요.`]
          }
        ])
      },
      {
        title: '예약 등록·변경',
        items: [
          '여러 날 이용: 일정 확정 후 공유 캘린더 권한을 드려요. 고객 예약을 직접 등록해 주세요.',
          '하루 이용·캘린더 권한 없음: 확정된 예약 시간을 인스타그램으로 보내 주세요.',
          '변경·취소: 작업일 전에 캘린더를 수정하거나 연락해 주세요.'
        ]
      },
      {
        title: '준비물',
        subsections: [
          { title: '가져오세요', paragraphs: ['타투 머신 · 바늘 · 컬러 잉크'] },
          { title: '스튜디오에서 제공해요', paragraphs: [
            '블랙 잉크 · 기본 소모품 · 위생 용품 · 스텐실 프린터(잉크젯·전통 방식)',
            `베드 ${policy.tattooBeds}개 · 최대 ${policy.maxArtists}명 동시 작업 · 에어컨`
          ] }
        ]
      },
      {
        title: '위치·문의',
        items: [policy.address, `구글 맵: ${policy.mapSearch}`,
          { text: `인스타그램: ${policy.instagramHandle}`, href: policy.instagramUrl }]
      }
    ]
  },
  en: {
    title: 'Guest artist guide',
    intro: '',
    summaryTitle: 'Rates',
    summaryItems: [
      `${policy.commissionRate} of daily tattoo revenue · Maximum ${policy.commissionDailyCap}/day`,
      `Monday–Saturday ${policy.openingHours} · Closed Sunday`
    ],
    sections: [
      {
        title: 'Booking a bed',
        paragraphs: ['Choose either option for each date.'],
        ...bedComparison(['Advance payment', 'Availability', 'Bed use'], [
          {
            title: 'Standard booking',
            values: ['None', `Priority until ${policy.priorityWindow.en} before your working date`, 'No specific bed assigned'],
            paragraphs: [`With less than ${policy.priorityWindow.en} to go, resident artists may use the space if you have no client appointments in the calendar. Add confirmed appointments promptly.`]
          },
          {
            title: 'Exclusive full-day bed',
            values: [`${policy.assignedBedAdvance} per date`, 'Secured even without client appointments', 'One bed exclusively yours all day'],
            paragraphs: [`Your ${policy.assignedBedAdvance} advance is deducted from that day’s commission. After payment, the bed is not assigned to other artists. The advance is non-refundable under all circumstances.`]
          }
        ])
      },
      {
        title: 'Appointments and changes',
        items: [
          'Multi-day visit: we give you shared calendar access once your dates are confirmed. Add your client appointments yourself.',
          'One-day visit without calendar access: send confirmed appointment times to our Instagram.',
          'Changes or cancellations: update the calendar or contact us before your working day.'
        ]
      },
      {
        title: 'What to bring',
        subsections: [
          { title: 'Bring', paragraphs: ['Tattoo machine · Needles · Colour inks'] },
          { title: 'We provide', paragraphs: [
            'Black ink · Basic consumables · Hygiene supplies · Stencil printers (inkjet and traditional)',
            `${policy.tattooBeds} beds · Up to ${policy.maxArtists} artists at once · Air conditioning`
          ] }
        ]
      },
      {
        title: 'Location and contact',
        items: [policy.address, `Google Maps: ${policy.mapSearch}`,
          { text: `Instagram: ${policy.instagramHandle}`, href: policy.instagramUrl }]
      }
    ]
  },
  fr: {
    title: 'Guide des artistes invités',
    intro: '',
    summaryTitle: 'Tarifs',
    summaryItems: [
      `${policy.commissionRate} du chiffre d’affaires tatouage du jour · Maximum ${policy.commissionDailyCap}/jour`,
      `Lundi–samedi ${policy.openingHours} · Fermé le dimanche`
    ],
    sections: [
      {
        title: 'Réserver une table',
        paragraphs: ['Choisissez une option pour chaque date.'],
        ...bedComparison(['Avance', 'Place', 'Utilisation'], [
          {
            title: 'Réservation standard',
            values: ['Aucune', `Priorité jusqu’à ${policy.priorityWindow.fr} avant votre date de travail`, 'Pas de table attitrée'],
            paragraphs: [`À moins d’${policy.priorityWindow.fr} de votre date, les artistes résidents peuvent utiliser la place si vous n’avez aucun rendez-vous au calendrier. Inscrivez rapidement vos rendez-vous confirmés.`]
          },
          {
            title: 'Table exclusive à la journée',
            values: [`${policy.assignedBedAdvance} par date`, 'Réservée même sans rendez-vous client', 'Une table pour vous toute la journée'],
            paragraphs: [`Votre avance de ${policy.assignedBedAdvance} est déduite de la commission du jour. Après paiement, la table n’est pas attribuée à d’autres artistes. L’avance n’est remboursable en aucun cas.`]
          }
        ])
      },
      {
        title: 'Rendez-vous et modifications',
        items: [
          'Plusieurs jours : nous vous donnons accès au calendrier partagé après confirmation des dates. Inscrivez vous-même vos rendez-vous clients.',
          'Une journée sans accès au calendrier : envoyez vos horaires confirmés à notre Instagram.',
          'Modification ou annulation : mettez le calendrier à jour ou contactez-nous avant votre jour de travail.'
        ]
      },
      {
        title: 'Matériel',
        subsections: [
          { title: 'À apporter', paragraphs: ['Machine à tatouer · Aiguilles · Encres couleur'] },
          { title: 'Nous fournissons', paragraphs: [
            'Encre noire · Consommables de base · Matériel d’hygiène · Imprimantes à stencil (jet d’encre et traditionnelles)',
            `${policy.tattooBeds} tables · Jusqu’à ${policy.maxArtists} artistes en même temps · Climatisation`
          ] }
        ]
      },
      {
        title: 'Adresse et contact',
        items: [policy.address, `Google Maps : ${policy.mapSearch}`,
          { text: `Instagram : ${policy.instagramHandle}`, href: policy.instagramUrl }]
      }
    ]
  }
};

export function normalizeGuestGuideLanguage(
  language,
  fallback = GUEST_GUIDE_DEFAULT_LANGUAGE
) {
  return GUEST_GUIDE_SUPPORTED_LANGUAGES.includes(language) ? language : fallback;
}

export function getGuestGuide(language, fallback = GUEST_GUIDE_DEFAULT_LANGUAGE) {
  return GUEST_GUIDES[normalizeGuestGuideLanguage(language, fallback)];
}

export function getGuestHomeText(language, fallback = GUEST_HOME_DEFAULT_LANGUAGE) {
  return GUEST_HOME_TEXT[normalizeGuestGuideLanguage(language, fallback)];
}

export function getGuestCommissionRate(commissionPercentage, defaultRate = policy.commissionRate) {
  if (commissionPercentage == null || String(commissionPercentage).trim() === '') {
    return defaultRate;
  }

  const percentage = Number(commissionPercentage);
  return Number.isFinite(percentage) ? `${percentage}%` : defaultRate;
}

export function getGuestHomeGuide(language, fallback = GUEST_HOME_DEFAULT_LANGUAGE) {
  return GUEST_HOME_GUIDE[normalizeGuestGuideLanguage(language, fallback)];
}
